import React, {useRef} from 'react';

import {renderUtils} from '@zoefin/design-system';

import Layout from '../../../../commons/FormsLibrary/components/Layout';
import {layoutFactory} from '../../form';

// Start to end there's total 14 steps (without animation, Real State, and Business)
const TOTAL_STEPS = 14;

export default layoutFactory(
  (
    step,
    {values, navigation, additionalProps, getStepValidation, prev, next},
  ) => {
    const hasAdvisorIsDefined = useRef(false);

    const {simpleLayout, skip} = additionalProps;
    const skipIntro = skip.includes('intro');
    const hasContinueButton =
      navigation.currentStep === 'hasAdvisor'
        ? hasAdvisorIsDefined.current
        : true;

    // Progress is fully derived from the navigation history length, so it is
    // computed during render instead of being mirrored into state by an effect.
    const stepsCounter = navigation.history.length - 1;
    const totalSteps = skipIntro ? TOTAL_STEPS - 1 : TOTAL_STEPS;
    const progress = Math.trunc((stepsCounter * 95) / totalSteps);

    // Wait for the `hasAdvisor` to change
    renderUtils.useOnChange(values.hasAdvisor, (previousHasAdvisor) => {
      if (typeof previousHasAdvisor === 'undefined') {
        hasAdvisorIsDefined.current = true;
      }
    });

    const hideBackButton =
      (simpleLayout && navigation.currentStep === 'hasAdvisor') ||
      (skipIntro ? navigation.currentStep === 'hasAdvisor' : false);

    return (
      <Layout
        // Disable progress bar for the submission "animation" step
        progress={navigation.currentStep === 'animation' ? false : progress}
        currentStep={navigation.currentStep}
        continueButton={{
          isVisible: hasContinueButton,
          isValid: getStepValidation(navigation.currentStep),
        }}
        ui={{
          hideFooter: simpleLayout,
          hidePrivacyWidget: simpleLayout,
          hideBackButton,
          fullScreenStepWrapper: simpleLayout,
          inlineBackMobile: simpleLayout,
        }}
        prev={prev}
        next={next}>
        {step}
      </Layout>
    );
  },
);
